import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../../Base";
import { memo } from "react";
import { palette } from "../../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    marginTop: "10px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  green: {
    background: palette.btn.greenFill,
    color: palette.typography.white.high,
    border: palette.btn.greenBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.greenFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const ViewOverridesActions = memo(
  ({ disabled, onCancel, onSave, disabledNewOverride, onNewOverride }) => {
    const styles = useStyles();

    return (
      <View className={styles.container}>
        <Button
          className={styles.yellow}
          variant={"contained"}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          disabled={disabledNewOverride}
          className={styles.green}
          variant={"contained"}
          onClick={onNewOverride}
        >
          New Override
        </Button>
        <Button
          disabled={disabled}
          className={styles.blue}
          variant={"contained"}
          onClick={onSave}
        >
          Ok
        </Button>
      </View>
    );
  }
);
